// Port of api/fuel/app/classes/controller/api/monty/custom/nesting/clear.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Collection from 'offline/model/collection'
import { currentUser, persist, unauthorised, touchUser } from '../shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return unauthorised()

	var collectionId = parseInt(params.id, 10) || 0
	var collection = Collection.record({
		where: {
			user_id: user.get_id(),
			collection_id: collectionId
		}
	})

	if (!collection) return unauthorised()

	DB.run('UPDATE collection SET collection_nested = ? WHERE user_id = ? AND collection_nested = ? AND collection_nested_official = ?', [
		Constants.NESTED_NONE,
		user.get_id(),
		Constants.NESTED_OFFICIAL,
		collection.get_id()
	])

	DB.run('UPDATE collection SET collection_nested = ?, collection_nested_custom = 0 WHERE user_id = ? AND collection_nested = ? AND collection_nested_custom = ?', [
		Constants.NESTED_NONE,
		user.get_id(),
		Constants.NESTED_CUSTOM,
		collection.get_id()
	])

	touchUser(user)
	return persist({})
}
